import { PropTypes } from 'prop-types';
import React, { PureComponent } from 'react';
import Autosuggest from 'react-autosuggest';
import { injectIntl } from 'react-intl';

class SuggestedTextPicker extends PureComponent {
  static propTypes = {
    input: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      onChange: PropTypes.func.isRequired,
      onBlur: PropTypes.func,
    }),
    items: PropTypes.arrayOf(PropTypes.shape({})),
    itemCallback: PropTypes.func,
    intl: PropTypes.shape({}).isRequired,
    renderSuggestion: PropTypes.func,
    placeholder: PropTypes.string,
    containerClassName: PropTypes.string,
    matchProperty: PropTypes.string,
    updateOnType: PropTypes.bool,
    requireSelection: PropTypes.bool,
  };

  static defaultProps = {
    matchProperty: 'name',
    updateOnType: false,
    requireSelection: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.input.value,
      selectedValue: props.input.value,
      suggestions: props.items ? props.items : [],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.input.value !== this.props.input.value) {
      this.setState({
        value: this.props.input.value || '',
        selectedValue: this.props.input.value || '',
      });
    }
  }

  onSuggestionSelected = (event, selected) => {
    const selectedValue = selected.suggestion[this.props.matchProperty];
    this.setState({ value: selectedValue, selectedValue }, () => {
      this.props.input.onChange(selectedValue);
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({ suggestions: this.getSuggestions(value) });
  };

  onSuggestionsClearRequested = () => {
    this.setState((state) => ({
      suggestions: [],
      value: this.props.requireSelection ? state.selectedValue || '' : state.value,
    }));
  };

  // eslint-disable-next-line
  onChange = (event, { newValue }) => {
    this.setState({ value: newValue });
    if (this.props.requireSelection && this.props.input.value) {
      this.props.input.onChange('');
    } else if (!this.props.requireSelection && this.props.updateOnType) {
      this.props.input.onChange(newValue);
    }
  };

  resetToSelectedValue = () => {
    if (this.props.requireSelection) {
      this.setState({ value: this.state.selectedValue || '' });
    }
  };

  onBlur = () => {
    this.resetToSelectedValue();
    if (this.props.input.onBlur) {
      this.props.input.onBlur(this.state.selectedValue);
    }
  };

  getFuzzyMatches = (input) => (object) => {
    const tokens = object[this.props.matchProperty].split('');
    let searchPosition = 0;

    for (const token of tokens) {
      if (token.toLowerCase() === input[searchPosition]) {
        searchPosition += 1;
        if (searchPosition >= input.length) {
          break;
        }
      }
    }

    if (searchPosition !== input.length) {
      return {};
    }

    return { ...object, name: tokens.join('') };
  };

  getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();

    const items = this.props.itemCallback ? this.props.itemCallback() : this.props.items;
    return items
      .map(this.getFuzzyMatches(inputValue))
      .filter((result) => result[this.props.matchProperty]);
  };

  getSuggestionValue = (suggestion) => suggestion[this.props.matchProperty];

  defaultRenderSuggestion = (suggestion) => (
    <div className="suggestion">
      <span>{suggestion[this.props.matchProperty]}</span>
    </div>
  );

  renderSuggestion = (suggestion) => {
    if (this.props.renderSuggestion) {
      return this.props.renderSuggestion(suggestion);
    }
    return this.defaultRenderSuggestion(suggestion);
  };

  renderInputComponent = (inputProps) => <input {...inputProps} className="form-control" />;

  render() {
    const inputProps = {
      placeholder: this.props.intl.formatMessage({
        id: this.props.placeholder,
      }),
      value: this.state.value,
      onChange: this.onChange,
      onBlur: this.onBlur,
    };

    return (
      <Autosuggest
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
        renderInputComponent={this.renderInputComponent}
        shouldRenderSuggestions={() => true}
        theme={{
          container: this.props.containerClassName || '',
          suggestionsContainer: 'suggestions-container',
          suggestionsList: 'suggestions-list',
        }}
      />
    );
  }
}

export default injectIntl(SuggestedTextPicker);
